(function () {
    'use strict';
    $(document).ready(function () {
        
        // function setCookie(cname, cvalue, exdays) {
        //     const d = new Date();
        //     d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        //     let expires = "expires=" + d.toUTCString();
        //     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        // }

        function getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        $('.video-container').find('video, .play').on('click', function(e){
            e.preventDefault();
            var video = $(this).parent().find('video')[0];
            var play = $(this).parent().find('.play')[0];
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }

            $(this).parent().find('.play').fadeToggle();
        });

        // SOCIAL SHARING
        const $share = $('#share');
        $share.css('opacity', 1);
        $share.jsSocials({
            showLabel: false,
            showCount: false,
            shareIn: "popup",
            text: document.title,
            url: window.location.href,
            shares: [
                {
                    share: "facebook",
                    logo: `${$share.attr('data-templateURL')}/dist/images/facebook.svg`,
                    inlineSvg: true,
                },
                {
                    share: "twitter",
                    logo: `${$share.attr('data-templateURL')}/dist/images/twitter.svg`,
                    inlineSvg: true,
                    via: "pgnig",
                },
                {
                    share: "linkedin",
                    logo: `${$share.attr('data-templateURL')}/dist/images/linkedin.svg`,
                    inlineSvg: true,
                }
            ]
        });

        //tools show/hide
        $('#tools-toggle').on('click', function () {
            $('.tools-list').animate({
                height: 'toggle'
            });
            $(this).toggleClass('opened');
        });

        //Quotes slider
        $('.subpage .swiper-quotes-slider').each(function (index) {
            var quotationsSwiper = new Swiper($(this)[0], {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 30,
                navigation: {
                    prevEl: '.swiper-button-prev',
                    nextEl: '.swiper-button-next',
                },
                breakpoints: {
                    767: {
                        slidesPerView: 1,
                    }
                }
            });
        });

        //Shuffle letters
        gsap.set(".number", {
            opacity: 0,
        });
        ScrollTrigger.batch(".number", {
            onEnter: batch => gsap.to(batch, {
                opacity: 1,
                delay: .5,
                duration: .5,
                stagger: .25,
                onStart: function() {
                    if ($(batch).find('.number-value').length) {

                        $(batch).find('.number-value').each(function() {
                            const number = $(this);
                            if (!number.hasClass('counted')) {
                                let numberText = number.text();
                                number.empty();
                                number.shuffleLetters({
                                    "text": numberText,
                                    "fps": 16,
                                    "step": 1
                                })
                                number.addClass('counted');
                            }
                        });

                    }
                }
            }),
            start: "top 80%",
        });

        //Download files gsap fix
        if (window.matchMedia("(min-width: 768px)").matches) {
            $('.download-files').each(function() {
                var fThis = $(this);
                ScrollTrigger.create({
                    trigger: fThis.find(".download-files-list"),
                    pin: fThis.find(".files-group-desc"),
                    start: "top 30px",
                    end: "bottom " + (fThis.find('.files-group-desc').height() + 30) + "px"
                });
            });
        }

        //Download files
        $('.download-files .file-protected').on('click', function(e) {            
            e.preventDefault(); 
            var fId = $(this).data('file-id');                    
            
            if (!getCookie('cyber360usrdwnldfl')) {
                $('.download-files-popup').attr('data-fid', fId);
                $('.download-files-popup').fadeIn({
                    start: function () {
                        $(this).css({
                            display: "flex"
                        })
                    }
                });
                $('.subpage').addClass('active-gate');
            } else {                
                location.href = "/df.php?fid="+fId;    
            } 
        });
        
        $('.download-files .download-files-popup-close').on('click', function() {
            $('.download-files-popup').attr('data-fid', '');
            $('#df-form').trigger('reset');
            $('.download-files-popup').hide();
            $('.subpage').removeClass('active-gate');
        });
        
        function validatePhone(phone) {
            const re = /^[0-9+-\\(\\)\\ \\#]{1,12}$/;
            return re.test(String(phone));
        }
        
        function validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
        
        $('#df-submit').on('click', function (e) {
            e.preventDefault();                       
             
            $('.df-error').hide();

            var isAllValid = true;
            
            if (!$('#df-name').val()) {                
                $('#df-name').siblings('.df-error').slideDown();
                isAllValid = false;
            }   
            
            if (validatePhone($('#df-phone').val()) === false) {
                $('#df-phone').siblings('.df-error').slideDown();
                isAllValid = false;
            }   

            if (validateEmail($('#df-email').val()) === false) {
                $('#df-email').siblings('.df-error').slideDown();
                isAllValid = false;
            }        
            
            $('.df-field-checkbox-consent-required').each(function() {
                if (!$(this).find('input[type=checkbox]').is(':checked')) {
                    $(this).find('input[type=checkbox]').siblings('.df-error').slideDown();
                    isAllValid = false;
                }
            });    

            if (!isAllValid) {
                return;
            }
            
            $('.df-downloading').slideUp();
            $('.df-downloading').slideDown();
            
            //setCookie('cyber360usrdwnldfl', '1', 30);    
            var dfName = $('#df-name').val();
            var dfPhone = $('#df-phone').val();
            var dfEmail = $('#df-email').val();
            var dfFields = '&dfname='+dfName+'&dfphone='+dfPhone+'&dfemail='+dfEmail;
            var fileId = $('.download-files-popup').data('fid');            
            location.href = "/df.php?fid="+fileId+dfFields;
            
            setTimeout(function() {
                $('.download-files-popup').attr('data-fid', '');
                $('#df-form').trigger('reset');
                $('.df-downloading').slideUp();
                $('.download-files-popup').hide();
                $('.subpage').removeClass('active-gate');
            }, 3000);            
        });
        
        $('#df-form .field-checkbox .expand').on('click', function(e) {
            e.preventDefault();
            $(this).siblings('label').children('p:not(:first-child)').slideToggle();
            var text = $(this).text();
            $(this).text(text == "Pokaż więcej" ? "Pokaż mniej" : "Pokaż więcej");
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse, .subpage .accordion .collapse').on('shown.bs.collapse', function () {
            const positionTop = $(this).parent().offset().top; // - $('header').height();
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
            $(window).resize();
        });

        // responsive image enlarging
        $('.popup-trigger').on('click', function (e) {
            $(this).parent().find('.popup-image-container').fadeIn();
            e.preventDefault();
            return false;
        });

        $('.popup-image-container').on('click', function () {
            $(this).fadeOut();
        });

        //Lottie

        var controledAnim = lottie.loadAnimation({
            container: document.getElementById('controled-animation'),
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: '/wp-content/themes/wp-bootstrap-gulp/dist/animations/cyber-tab.json'
        });

        var controledAnimCtn = 1;

        var controledAnimInterval = setInterval(function() {
            $('.anim-menu').find('.play-lottie[data-layer=' + controledAnimCtn + ']').trigger('click');
        }, 5000);

        $('.play-lottie').on('click', function (evt) {

            if (evt.originalEvent !== undefined) {
                clearInterval(controledAnimInterval);
            }

            var layerId = $(this).data('layer');
            controledAnimCtn = layerId < 4 ? controledAnimCtn+1 : 1;

            var currFrameEnd = $('.anim-menu').find('.playing').data('frame-end');
            if (currFrameEnd) {
                var paddFrame = currFrameEnd + 25;
                $('.anim-menu').find('.playing').removeClass('playing');
                controledAnim.playSegments([currFrameEnd, paddFrame], true);
            }

            $(this).addClass('playing');
            var newFrameStart = $(this).data('frame-start');
            var newFrameEnd = $(this).data('frame-end');

            var forceFlag = currFrameEnd ? false : true;

            controledAnim.playSegments([newFrameStart, newFrameEnd], forceFlag);

            $(this).siblings('.desc').slideDown().parent().siblings().children('.desc').slideUp();
        });

        ScrollTrigger.create({
            trigger: ".infographics-interactive .points-line",
            pin: false,
            start: "top center",
            end: "bottom center",
            onUpdate: function (self) {
                var scrollValue = self.progress * 100;
                var scrollValuePercents = Math.round((scrollValue + Number.EPSILON) * 100) / 100;

                if (scrollValuePercents > 5) {
                    $('.infographics-interactive .points-indicator').css({
                        'height': scrollValuePercents + '%',
                    });
                }
            }
        });

        $(".lottie-animation").each(function () {
            const container = $(this)[0];
            const animation = bodymovin.loadAnimation({
                container: container,
                path: '/wp-content/themes/wp-bootstrap-gulp/dist/animations/' + $(this).data('animation') + '/data.json',
                renderer: 'svg',
                loop: true,
                controls: false,
                autoplay: true,
                name: $(this).data('animation-name'),
                rendererSettings: {
                    imagePreserveAspectRatio: "xMinYMin slice"
                }
            });
        });

    });
}(jQuery));
